import { render } from "./EditBM.vue?vue&type=template&id=4d2d61db"
import script from "./EditBM.vue?vue&type=script&lang=js"
export * from "./EditBM.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__